import { createStore } from "vuex";
import axios from "axios";
import { awsConfig } from "../aws-config";

export default createStore({
  state: {
    token: null,
    user: null,
    clients: [],
    lastFetchedTime: null,
    cacheTimeout: 5 * 60 * 1000, // 5 minutes in milliseconds
    selectedClient: {}, // For client context
  },
  getters: {
    isAuthenticated: (state) => !!state.token,
    getToken: (state) => state.token,
    getUser: (state) => state.user,
    getClients: (state) => state.clients,
    getSelectedClient: (state) => state.selectedClient,
    shouldFetchClients: (state) => {
      if (!state.lastFetchedTime) return true;
      const now = Date.now();
      return now - state.lastFetchedTime > state.cacheTimeout;
    },
    isAdmin: (state) => state.user?.isAdmin === true,
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setUser(state, user) {
      state.user = user;
    },
    setSelectedClient(state, client) {
      state.selectedClient = client;
    },
    setClients(state, clients) {
      state.clients = clients;
      state.lastFetchedTime = Date.now();
    },
    clearClientsCache(state) {
      state.clients = [];
      state.lastFetchedTime = null;
    },
    clearAuth(state) {
      state.token = null;
      state.user = null;
    },
  },
  actions: {
    async login({ commit }, { token, user }) {
      commit("setToken", token);
      commit("setUser", user);
      // Store token in sessionStorage for persistence
      sessionStorage.setItem("jwtToken", token);
      sessionStorage.setItem("user", JSON.stringify(user));
    },
    async logout({ commit }) {
      commit("clearAuth");
      sessionStorage.removeItem("jwtToken");
      sessionStorage.removeItem("user");
      commit("clearClientsCache");
    },
    // Initialize auth state from session storage
    initAuth({ commit }) {
      const token = sessionStorage.getItem("jwtToken");
      const user = JSON.parse(sessionStorage.getItem("user"));
      if (token && user) {
        commit("setToken", token);
        commit("setUser", user);
      }
    },
    async fetchClients({ commit, getters }) {
      console.log("store fetchClientsapiurl", awsConfig.Api.ClientsEndpoint);
      try {
        const response = await axios.get(awsConfig.Api.ClientsEndpoint, {
          headers: {
            Authorization: `Bearer ${getters.getToken}`,
          },
        });
        const clients =
          response.data.clients || response.data.Items || response.data;
        console.log(clients);
        commit("setClients", clients);
        return clients;
      } catch (error) {
        console.error("Error fetching clients:", error);
        throw error;
      }
    },
    // Invalidate clients cache and optionally fetch fresh data
    async invalidateClientsCache(
      { commit, dispatch },
      { fetchFresh = true } = {}
    ) {
      commit("clearClientsCache");
      if (fetchFresh) {
        await dispatch("fetchClients");
      }
    },
  },
  modules: {},
});
